module.exports = __webpack_public_path__ + "assets/img/prize-1.9b6a55ae.jpg";